/* eslint-disable */

import { Box } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import http from '../../api/axiosInstance';
import { Link } from 'react-router-dom';
import jalaliMoment from "jalali-moment"
import Cookies from 'js-cookie'

const events = [
  { title: 'Meeting', start: new Date() }
]


export function Calendar() {
  const dataFetchedRef = useRef(false);
  const [expiryProp, setExpiryProp] = useState([])
  const [expiryAplic, setExpiryAplic] = useState([])
  const [reminders, setReminders] = useState([])
  const [eventLoading, setEventLoading] = useState(false)


  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;

    setTimeout(() => {
      console.log("dfd")
      var calendarEl = document.getElementById('calendar');
      var calendar = new FullCalendar.Calendar(calendarEl, {
        initialView: 'dayGridMonth',
        locale: "fa",
        firstDay: 6,
        direction: "rtl",
        headerToolbar: {
          end: 'prev,next'
        },
        footerToolbar: { end: 'today' },
        views: {
          agendaThreeDay: {
            type: 'agenda',
            duration: { days: 3 },
            buttonText: '3 day'
          },
          defaultView: 'agendaThreeDay'
        },
        buttonIcons: {
          prev: 'chevron-left',
          next: 'chevron-right',
          today: 'chevron-left',
        }
      });



      calendar.render();



      var prevBtn = document.getElementsByClassName('fc-prev-button')
      var span = document.createElement('span');

      span.textContent = 'ماه قبل';
      prevBtn[0].appendChild(span);

      var nextBtn = document.getElementsByClassName('fc-next-button')
      var spanNext = document.createElement('span');

      spanNext.textContent = 'ماه بعد';
      nextBtn[0].prepend(spanNext);

      var todayBtn = document.getElementsByClassName('fc-today-button')
      var spanToday = document.createElement('span');

      spanToday.textContent = 'امروز';
      todayBtn[0].prepend(spanToday);

      Array.from(document.querySelectorAll(".fc-day")).forEach(
        (ele) => {
          ele.addEventListener("click", async function () {
            setExpiryAplic([])
            setExpiryProp([])
            setEventLoading(true)

            document.querySelectorAll(".fc-day").forEach((element) => {
              element.classList.remove('selected-day');
            });
            ele.classList.add('selected-day')


            console.log((+(new Date(ele.getAttribute('data-date')))) / 1000)
            try {
              const response = await http({
                url: "/calendar/events",
                method: "POST",
                data: {
                  "Date": (+(new Date(ele.getAttribute('data-date')))) / 1000
                },
                headers: {
                  "Authorization": `Bearer ${Cookies.get('token')}`
                }
              })

              if (response.data.result && response.data.result.expiry_properties.length) {
                console.log(response, response.data.result.expiry_properties)

                setExpiryProp(response.data.result.expiry_properties)
              }
              else
                setExpiryProp([])

              if (response.data.result && response.data.result.expiry_applicants.length)
                setExpiryAplic(response.data.result.expiry_properties)
              else
                setExpiryAplic([])

              if (response.data.result && response.data.result.reminders.length)
                setReminders(response.data.result.reminders)
              else
                setReminders([])

            } catch (e) {
              console.error(e);
            }

            setEventLoading(false)
          });
        })
    }, 500)
  }, [])

  // useEffect(() => {
  //   console.log("expiry prop",expiryProp)
  // },[expiryProp])

  return (
    <div>
      <Box className="calendar-img"></Box>
      <Box className="calendar-container">
        <div id='calendar'></div>
      </Box>
      {eventLoading ? <Box sx={{ textAlign: "center", p: 2 }}>در حال بارگذاری...</Box> :
        <Box className="events-container" sx={{ p: 2 }}>


          {reminders.length ?
            reminders.map((item, index) => {
              return <Box className="event-item">
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} key={index}>
                  <Box>
                    یادآوری {item.Title}
                  </Box>

                </Box>
                <Box sx={{ mt: 1 }}>
                  {item.Description}
                </Box>
              </Box>
            })

            : ""}

          {expiryProp.length ?
            expiryProp.map((item, index) => {
              return <Box className="event-item">
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} key={index}>
                  <Box>
                    بازیابی ملک {item.PropertyType} در {item.PropertyArea}
                  </Box>
                  <Link to={`/property/${item.Id}`} className='event-link'>
                    {item.Row}
                  </Link>
                </Box>
                <Box sx={{ mt: 1 }}>
                  در {jalaliMoment(new Date(item.ExpireDate * 1000)).locale('fa').fromNow()}
                </Box>
              </Box>
            })

            : ""}





          {expiryAplic.length ?
            expiryAplic.map((item, index) => {
              return <Box className="event-item">
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} key={index}>
                  <Box>
                    بازیابی تقاضا {item.PropertyType} در {item.PropertyArea}
                  </Box>
                  <Link to={`/applicant/${item.Id}`} className='event-link'>
                    {item.Row}
                  </Link>
                </Box>
                <Box sx={{ mt: 1 }}>
                  در {jalaliMoment(new Date(item.ExpireDate * 1000)).locale('fa').fromNow()}
                </Box>
              </Box>
            }) : ""}

          {!expiryProp.length && !expiryAplic.length && !eventLoading ? <Box sx={{ textAlign: "center" }}>رویدادی موجود نیست</Box> : ""}
        </Box>
      }
    </div>
  )
}

// a custom render function
function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b>
      <i>{eventInfo.event.title}</i>
    </>
  )
}